module.exports = __webpack_public_path__ + "static/media/480.a9c1cb9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-move-shit-around/light/480.png
// module id = 2258
// module chunks = 2